// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout';
var marketingRouter = {
  path: '/marketing',
  component: Layout,
  redirect: '/marketing/integral/integralconfig',
  name: 'Marketing',
  meta: {
    title: '营销',
    icon: 'clipboard'
  },
  children: [{
    path: 'coupon',
    component: function component() {
      return import('@/views/marketing/coupon/index');
    },
    name: 'Coupon',
    meta: {
      title: '优惠券',
      icon: ''
    },
    children: [{
      path: 'template',
      component: function component() {
        return import('@/views/marketing/coupon/couponTemplate/index');
      },
      name: 'couponTemplate',
      hidden: true,
      meta: {
        title: '优惠券模板',
        icon: ''
      }
    }, {
      path: 'list/save/:id?',
      name: 'couponAdd',
      meta: {
        title: '优惠劵添加',
        noCache: true,
        activeMenu: "/marketing/coupon/list"
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/coupon/list/creatCoupon');
      }
    }, {
      path: 'list/view/:id',
      name: 'couponView',
      meta: {
        title: '优惠券查看',
        noCache: true,
        activeMenu: "/marketing/coupon/list"
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/coupon/list/creatCoupon');
      }
    }, {
      path: 'list',
      component: function component() {
        return import('@/views/marketing/coupon/list/index');
      },
      name: 'List',
      meta: {
        title: '优惠券列表',
        icon: ''
      }
    }, {
      path: 'record',
      component: function component() {
        return import('@/views/marketing/coupon/record/index');
      },
      name: 'Record',
      meta: {
        title: '领取记录',
        icon: ''
      }
    }]
  }, {
    path: 'giftCard',
    component: function component() {
      return import('@/views/marketing/giftCard/index');
    },
    redirect: '/marketing/giftCard/list',
    name: 'GiftCard',
    meta: {
      title: '礼品卡',
      icon: '',
      activeMenu: '/marketing',
      sideActiveMenu: '/marketing/giftCard'
    },
    alwaysShow: true,
    children: [{
      path: 'list/create',
      name: 'giftCardCreate',
      meta: {
        title: '新增礼品卡活动',
        noCache: true,
        activeMenu: '/marketing',
        sideActiveMenu: '/marketing/giftCard'
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/giftCard/list/create');
      }
    }, {
      path: 'list/detail/:id',
      name: 'giftCardDetail',
      meta: {
        title: '礼品卡活动详情',
        noCache: true,
        activeMenu: '/marketing',
        sideActiveMenu: '/marketing/giftCard'
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/giftCard/list/detail');
      }
    }, {
      path: 'list',
      component: function component() {
        return import('@/views/marketing/giftCard/list/index');
      },
      name: 'giftCardList',
      meta: {
        title: '礼品卡活动',
        icon: '',
        activeMenu: '/marketing',
        sideActiveMenu: '/marketing/giftCard'
      }
    }]
  }, {
    path: 'verificationGift',
    component: function component() {
      return import('@/views/marketing/verificationGift/index');
    },
    redirect: '/marketing/verificationGift/activity',
    name: 'VerificationGift',
    meta: {
      title: '核销有礼',
      icon: '',
      activeMenu: '/marketing',
      sideActiveMenu: '/marketing/verificationGift'
    },
    alwaysShow: true,
    children: [{
      path: 'list/form/:id?',
      name: 'verificationGiftForm',
      meta: {
        title: '核销有礼活动编辑',
        noCache: true,
        activeMenu: '/marketing',
        sideActiveMenu: '/marketing/verificationGift'
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/verificationGift/list/form');
      }
    }, {
      path: 'list/detail/:id',
      name: 'verificationGiftDetail',
      meta: {
        title: '核销有礼活动详情',
        noCache: true,
        activeMenu: '/marketing',
        sideActiveMenu: '/marketing/verificationGift'
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/verificationGift/list/detail');
      }
    }, {
      path: 'activity',
      component: function component() {
        return import('@/views/marketing/verificationGift/list/index');
      },
      name: 'verificationGiftActivity',
      meta: {
        title: '活动管理',
        icon: '',
        activeMenu: '/marketing',
        sideActiveMenu: '/marketing/verificationGift'
      }
    }, {
      path: 'faq',
      component: function component() {
        return import('@/views/marketing/verificationGift/faq/index');
      },
      name: 'verificationGiftFaq',
      meta: {
        title: '常见问题',
        icon: '',
        activeMenu: '/marketing',
        sideActiveMenu: '/marketing/verificationGift'
      }
    }, {
      path: 'record',
      component: function component() {
        return import('@/views/marketing/verificationGift/list/index');
      },
      name: 'verificationGiftRecord',
      meta: {
        title: '核销记录',
        icon: '',
        activeMenu: '/marketing',
        sideActiveMenu: '/marketing/verificationGift'
      }
    }, {
      path: 'list',
      component: function component() {
        return import('@/views/marketing/verificationGift/list/index');
      },
      name: 'verificationGiftList',
      hidden: true,
      meta: {
        title: '核销有礼活动',
        icon: '',
        activeMenu: '/marketing',
        sideActiveMenu: '/marketing/verificationGift'
      }
    }]
  }, {
    path: 'activityConfig',
    component: function component() {
      return import('@/views/marketing/activityConfig/index');
    },
    name: 'activityConfig',
    meta: {
      title: '活动配置',
      icon: '',
      activeMenu: '/marketing'
    }
  }, {
    path: 'crowdTest/list',
    component: function component() {
      return import('@/views/marketing/crowdTest/list/index');
    },
    name: 'crowdTestList',
    meta: {
      title: '众测活动',
      icon: '',
      activeMenu: '/marketing'
    }
  }, {
    path: 'crowdTest/form/:id?',
    name: 'crowdTestForm',
    meta: {
      title: '众测活动编辑',
      noCache: true,
      activeMenu: '/marketing/crowdTest/list'
    },
    hidden: true,
    component: function component() {
      return import('@/views/marketing/crowdTest/list/form');
    }
  }, {
    path: 'crowdTest/detail/:id',
    name: 'crowdTestDetail',
    meta: {
      title: '众测活动详情',
      noCache: true,
      activeMenu: '/marketing/crowdTest/list'
    },
    hidden: true,
    component: function component() {
      return import('@/views/marketing/crowdTest/list/detail');
    }
  }, {
    path: 'bargain',
    component: function component() {
      return import('@/views/marketing/bargain/index');
    },
    name: 'Bargain',
    meta: {
      title: '砍价管理',
      icon: ''
    },
    alwaysShow: true,
    hidden: true,
    children: [{
      path: 'bargainGoods',
      component: function component() {
        return import('@/views/marketing/bargain/bargainGoods/index');
      },
      name: 'bargainGoods',
      meta: {
        title: '砍价商品',
        icon: ''
      }
    }, {
      path: 'creatBargain/:id?',
      component: function component() {
        return import('@/views/marketing/bargain/bargainGoods/creatBargain');
      },
      name: 'creatBargain',
      meta: {
        title: '砍价商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/bargain/bargainGoods"
      }
    }, {
      path: 'bargainList',
      component: function component() {
        return import('@/views/marketing/bargain/bargainList/index');
      },
      name: 'bargainList',
      meta: {
        title: '砍价列表',
        icon: ''
      }
    }]
  }, {
    path: 'groupBuy',
    component: function component() {
      return import('@/views/marketing/groupBuy/index');
    },
    name: 'groupBuy',
    meta: {
      title: '拼团管理',
      icon: ''
    },
    hidden: true,
    children: [{
      path: 'groupGoods',
      component: function component() {
        return import('@/views/marketing/groupBuy/groupGoods/index');
      },
      name: 'groupGoods',
      meta: {
        title: '拼团商品',
        icon: ''
      }
    }, {
      path: 'creatGroup/:id?/:type?',
      component: function component() {
        return import('@/views/marketing/groupBuy/groupGoods/creatGroup');
      },
      name: 'creatGroup',
      meta: {
        title: '拼团商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/groupBuy/groupGoods"
      }
    }, {
      path: 'groupList',
      component: function component() {
        return import('@/views/marketing/groupBuy/groupList/index');
      },
      name: 'groupList',
      meta: {
        title: '拼团列表',
        icon: ''
      }
    }]
  }, {
    path: 'seckill',
    component: function component() {
      return import('@/views/marketing/seckill/index');
    },
    name: 'Seckill',
    meta: {
      title: '秒杀管理',
      icon: ''
    },
    children: [{
      path: 'config',
      component: function component() {
        return import('@/views/marketing/seckill/seckillConfig/index');
      },
      name: 'SeckillConfig',
      meta: {
        title: '秒杀配置',
        icon: ''
      }
    }, {
      path: 'list/:timeId?',
      component: function component() {
        return import('@/views/marketing/seckill/seckillList/index');
      },
      name: 'SeckillList',
      meta: {
        title: '秒杀商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/seckill/list"
      }
    }, {
      path: 'creatSeckill/:name?/:timeId?/:id?',
      component: function component() {
        return import('@/views/marketing/seckill/seckillList/creatSeckill');
      },
      name: 'CreatSeckill',
      meta: {
        title: '添加秒杀商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/seckill/list"
      }
    }]
  }, {
    path: 'integral',
    component: function component() {
      return import('@/views/marketing/integral/index');
    },
    name: 'Integral',
    meta: {
      title: '积分',
      icon: ''
    },
    children: [{
      path: 'integralconfig',
      component: function component() {
        return import('@/views/marketing/integral/config/index');
      },
      name: 'integralConfig',
      meta: {
        title: '积分配置',
        icon: ''
      }
    }, {
      path: 'integrallog',
      component: function component() {
        return import('@/views/marketing/integral/integralLog/index');
      },
      name: 'integralLog',
      meta: {
        title: '积分日志',
        icon: ''
      }
    }]
  }, {
    path: 'inviteReward/activity',
    component: function component() {
      return import('@/views/marketing/inviteReward/activity/index');
    },
    name: 'inviteRewardActivity',
    meta: {
      title: '邀请有礼活动',
      icon: ''
    }
  }, {
    path: 'replyReward/list',
    component: function component() {
      return import('@/views/marketing/replyReward/list/index');
    },
    name: 'replyRewardList',
    meta: {
      title: '评价有礼活动',
      icon: '',
      activeMenu: '/marketing'
    }
  }, {
    path: 'replyReward/form/:id?',
    component: function component() {
      return import('@/views/marketing/replyReward/list/form');
    },
    name: 'replyRewardForm',
    hidden: true,
    meta: {
      title: '评价有礼活动编辑',
      noCache: true,
      activeMenu: '/marketing/replyReward/list'
    }
  }, {
    path: 'replyReward/detail/:id',
    component: function component() {
      return import('@/views/marketing/replyReward/list/detail');
    },
    name: 'replyRewardDetail',
    hidden: true,
    meta: {
      title: '评价有礼活动详情',
      noCache: true,
      activeMenu: '/marketing/replyReward/list'
    }
  }, {
    path: 'replyReward/record',
    component: function component() {
      return import('@/views/marketing/replyReward/list/record');
    },
    name: 'replyRewardRecord',
    meta: {
      title: '评价有礼赠送记录',
      noCache: true,
      activeMenu: '/marketing/replyReward/list'
    }
  }, {
    path: 'atmosphere',
    name: 'atmosphere',
    meta: {
      title: '活动氛围',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/atmosphere/index');
    },
    children: [{
      path: 'list',
      name: "atmosphereList",
      meta: {
        title: '氛围列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/list');
      }
    }, {
      path: 'add/:id?',
      name: "addAtmosphere",
      meta: {
        title: '添加活动氛围',
        noCache: true,
        activeMenu: "/marketing/atmosphere/list"
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/addAtmosphere');
      }
    }]
  }, {
    path: 'border',
    name: 'border',
    meta: {
      title: '活动边框',
      icon: ''
    },
    component: function component() {
      return import('@/views/marketing/border/index');
    },
    children: [{
      path: 'list',
      name: "borderList",
      meta: {
        title: '活动边框列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/list');
      }
    }, {
      path: 'add/:id?',
      name: "addBorder",
      meta: {
        title: '添加活动边框',
        noCache: true,
        activeMenu: "/marketing/border/list"
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/addAtmosphere');
      }
    }]
  }, {
    path: 'memberRight',
    name: 'memberRight',
    meta: {
      title: '会员权益',
      icon: ''
    },
    component: function component() {
      return import('@/views/marketing/memberRight/index');
    },
    children: [{
      path: 'list',
      name: 'memberRightList',
      meta: {
        title: '会员权益列表',
        icon: ''
      },
      component: function component() {
        return import('@/views/marketing/memberRight/list');
      }
    }, {
      path: 'create/:id?',
      name: 'memberRightCreate',
      meta: {
        title: '添加会员权益',
        icon: '',
        activeMenu: '/marketing/memberRight/list'
      },
      component: function component() {
        return import('@/views/marketing/memberRight/create');
      },
      hidden: true
    }]
  }]
};
export default marketingRouter;